import React, { FunctionComponent, useState } from 'react';
import { ArrowBackOutlined, EditOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import i18next from 'i18next';

import { history } from 'helpers/history';

import DeathsShow from 'views/public/DeathsView/components/DeathsShow';
import DivorcesShow from 'views/public/DivorcesView/components/DivorcesShow';
import JewishnessShow from 'views/public/JewishnessView/components/JewishnessShow';
import MarriagesShow from 'views/public/MarriagesView/components/MarriagesShow';
import MatzevaShow from 'views/public/MatzevaView/components/MatzevaShow';
import ReservationsShow from 'views/public/ReservationsView/components/ReservationsShow';
import SelectInput from 'components/inputs/SelectInput';

import { IDeath } from 'types/deaths.types';
import { IDivorce } from 'types/divorces.types';
import { IJewishness } from 'types/jewishness.types';
import { IMarriage } from 'types/marriages.types';
import { IMatzeva } from 'types/matzeva.types';
import { IReservation } from 'types/reservations.types';
import {
  ViewContainer,
  ViewContent,
  TitleContainer,
  Title,
  TableContainer,
  CustomIconButton,
  FilePreview,
} from 'styles/view';

import { IProceduresShowProps } from './types';
import './i18n';

const ProceduresShow: FunctionComponent<IProceduresShowProps> = (props: IProceduresShowProps) => {
  const { item } = props;
  const [selectedFile, setSelectedFile] = useState<string | string[]>('');

  const file = item?.files?.find(({ id }) => id.toString() === selectedFile);

  return (
    <ViewContainer auth data-testid="procedures-show">
      <ViewContent auth>
        <TitleContainer>
          <CustomIconButton onClick={history.goBack}>
            <ArrowBackOutlined />
          </CustomIconButton>
          <Title>{i18next.t<string>('PROCEDURES_SHOW:TITLE')}</Title>
          <CustomIconButton onClick={() => history.push(`/procedures/${item?.id}/edit`)}>
            <EditOutlined />
          </CustomIconButton>
        </TitleContainer>
        {item && (
          <>
            <TableContainer>
              <tbody>
                <tr>
                  <td>{i18next.t<string>('PROCEDURES_SHOW:ID')}</td>
                  <td>{item?.id}</td>
                </tr>
                <tr>
                  <td>{i18next.t<string>('PROCEDURES_SHOW:NAME')}</td>
                  <td>{item?.name}</td>
                </tr>
                <tr>
                  <td>{i18next.t<string>('PROCEDURES_SHOW:STATE')}</td>
                  <td>{item?.stateName}</td>
                </tr>
                <tr>
                  <td>{i18next.t<string>('PROCEDURES_SHOW:TYPE')}</td>
                  <td>{item?.formTypeName}</td>
                </tr>
              </tbody>
            </TableContainer>
            {!!item.files?.length && (
              <>
                <Typography variant="h6">
                  {i18next.t<string>('PROCEDURES_SHOW:DOCUMENTS_INFORMATION')}
                </Typography>
                <br />
                <SelectInput
                  input={{
                    name: 'files',
                    onChange: setSelectedFile,
                    value: selectedFile,
                  }}
                  label={i18next.t<string>('PROCEDURES_SHOW:FILES')}
                  meta={{}}
                  options={item.files.map(({ id, name }) => ({
                    label: name,
                    value: id.toString(),
                  }))}
                />
                {file && (
                  <>
                    <FilePreview src={file.file} title="file" />
                    <br />
                  </>
                )}
              </>
            )}
            {item?.formType === 'Death' && (
              <DeathsShow item={item.form as IDeath} showTitle={false} />
            )}
            {item?.formType === 'Divorce' && (
              <DivorcesShow item={item.form as IDivorce} showTitle={false} />
            )}
            {item?.formType === 'Jewishness' && (
              <JewishnessShow item={item.form as IJewishness} showTitle={false} />
            )}
            {item?.formType === 'Marriage' && (
              <MarriagesShow item={item.form as IMarriage} showTitle={false} />
            )}
            {item?.formType === 'Matzeva' && (
              <MatzevaShow item={item.form as IMatzeva} showTitle={false} />
            )}
            {item?.formType === 'Reservation' && (
              <ReservationsShow item={item.form as IReservation} showTitle={false} />
            )}
          </>
        )}
      </ViewContent>
    </ViewContainer>
  );
};

export default ProceduresShow;
